/**
 * Модуль для работы с табами
 */

/**
 * Инициализирует табы
 * @param {Object} options - Опции инициализации
 * @param {string} options.tabSelector - Селектор табов
 * @param {string} options.panelSelector - Селектор панелей
 * @param {string} options.activeTabClass - Класс активного таба
 * @param {string} options.activePanelClass - Класс активной панели
 * @param {string} options.dataAttribute - Атрибут с данными для связи таба и панели
 */
export function initTabs({
  tabSelector,
  panelSelector,
  activeTabClass = '--active',
  activePanelClass = '--active',
  dataAttribute = 'data-tab',
}) {
  const tabs = document.querySelectorAll(tabSelector)
  const panels = document.querySelectorAll(panelSelector)

  if (!tabs.length || !panels.length) return

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const targetValue = tab.getAttribute(dataAttribute)

      // Удаляем активный класс у всех табов
      tabs.forEach((t) => t.classList.remove(activeTabClass))

      // Добавляем активный класс текущему табу
      tab.classList.add(activeTabClass)

      // Скрываем все панели
      panels.forEach((panel) => panel.classList.remove(activePanelClass))

      // Показываем нужную панель
      const targetPanel = document.querySelector(`${panelSelector}[${dataAttribute}="${targetValue}"]`)
      if (targetPanel) {
        targetPanel.classList.add(activePanelClass)
      }
    })
  })
}

/**
 * Инициализирует табы для курсов
 */
export function initCoursesTabs() {
  initTabs({
    tabSelector: '.courses__tab',
    panelSelector: '.courses__panel',
    activeTabClass: 'courses__tab--active',
    activePanelClass: 'courses__panel--active',
    dataAttribute: 'data-tab',
  })
}

/**
 * Инициализирует табы для бизнеса
 */
export function initBusinessTabs() {
  const businessTabs = document.querySelectorAll('.business__tab')

  if (!businessTabs.length) return

  businessTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      // Убираем активный класс со всех табов
      businessTabs.forEach((t) => t.classList.remove('business__tab--active'))

      // Добавляем активный класс текущему табу
      tab.classList.add('business__tab--active')

      // Скрываем все панели
      const panels = document.querySelectorAll('.business__panel')
      panels.forEach((panel) => panel.classList.remove('business__panel--active'))

      // Показываем нужную панель
      const targetPanel = document.getElementById(tab.dataset.target)
      if (targetPanel) {
        targetPanel.classList.add('business__panel--active')
      }
    })
  })
}




